<div class="row" style="height: 900px;background-color: white;">
  <div class="col-sm-12" style="position: relative;">
    <ng-container>
      <img src="./assets/images/atom_logo.png" style="margin-bottom: 10px;">
    </ng-container>

    <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
      (click)="toggleMobileMenu($event)">
      <i class="fa fa-fw fa-bars"></i>
    </button>

    <div class="row">
      <ng-template #contentTemplate>
        <!--- Sidemenu -->
        <div id="sidebar-menu">
          <!-- Left Menu Start -->
          <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
            <!-- {{menuItems}} -->
            <ng-container *ngFor="let item of menuItems">
              <!-- <li class="menu-title">{{ item?.label }}</li> -->
              <li>
                <a *ngIf="item.label == 'New Chat'" href="javascript:void(0);" class="is-parent" style="color: black;"
                  (click)="clearChat()">
                  <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
                  <span> New Chat </span>
                </a>

                <a *ngIf="item.label == 'Chat History'" href="javascript:void(0);" class="is-parent;has-arrow"
                  class="has-arrow" style="color: black;">
                  <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
                  <span> Chat History </span>
                </a>

                <a *ngIf="item.label == 'FAQs'" href="javascript:void(0);" class="is-parent;has-arrow" class="has-arrow"
                  style="color: black;">
                  <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
                  <span> FAQs </span>
                </a>

                <a *ngIf="item.label == 'Live Data'" href="javascript:void(0);" class="is-parent;has-arrow"
                  class="has-arrow" style="color: black;">
                  <i class="bx {{item.icon}}" *ngIf="item.icon"></i>
                  <span> Live Data </span>
                </a>

                <ul *ngIf="item.label == 'FAQs'" class="sub-menu" aria-expanded="false">
                  <li *ngFor="let ele of questions">
                    <a class="side-nav-link-a-ref" href="javascript:void(0);" (click)="onClickQuestion(ele)">
                      {{ ele.question }}
                    </a>

                  </li>
                </ul>
                <ul *ngIf="item.label == 'Chat History'" class="sub-menu" aria-expanded="false">
                  <li *ngFor="let chat of _allChatHistory">
                    <a class="side-nav-link-a-ref" href="javascript:void(0);" (click)="getChatHistory(chat)">
                      {{ chat.title }}
                    </a>

                  </li>
                </ul>

                <ul *ngIf="item.label == 'Live Data'" class="sub-menu" aria-expanded="false">
                  <li *ngFor="let data of liveData">
                    <a class="side-nav-link-a-ref" href="javascript:void(0);" (click)="onLiveDataClick(data)">
                      {{ data.question }}
                    </a>

                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </div>
      </ng-template>

      <div class="col-sm-2" style="position: relative;">
        <div class="vertical-menu" style="background-color: white;">
          <ngx-simplebar class="h-100" #componentRef>
            <div *ngIf="!isCondensed">
              <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            </div>
            <div *ngIf="isCondensed">
              <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
            </div>
          </ngx-simplebar>
        </div>
      </div>

      <div class="col-sm-10">
        <h3 *ngIf="!dataFlag"
          style="color: black;padding-top: 300px;text-align: center;font-size: 30px;color: black;font-family: 'poppins' !important;font-weight: 500 !important;">
          Ask Me Anything
        </h3>
        <div class="chat-container mt-2"
          [ngStyle]="{'height': dataFlag ? '500px' : 'auto', 'padding-top' : dataFlag ? '110px' : '20px'}">
          <div class="chat-window mt-3" #chatWindow>
            <div *ngFor="let msg of messages;" [ngClass]="msg.sender">
              <div class="message-bubble">
                <!-- Plain text message -->
                <ng-container *ngIf="msg.sender == 'user'">
                  {{ msg.text }}
                </ng-container>

                <ng-container *ngIf="msg.raw_text && msg.sender == 'ai'">
                  {{ msg.raw_text }} <br>
                  <button style="margin-top: 10px;border: none;background-color: white;padding: 0px;" matTooltip="copy"
                    [cdkCopyToClipboard]="msg.raw_text"><img src="assets/icons/content_copy.svg" alt=""></button>
                </ng-container>

                <!-- <ng-container *ngIf="msg.sender == 'ai' && msg.prefix !== ''">
                  {{ msg.text }}
                </ng-container> -->

                <ng-container *ngIf="msg.sender == 'ai' && msg.href">
                  <a (click)="redirectionMap(msg.href)" href="msg.href">Track your driver's location here</a>
                </ng-container>
                <!-- Table message -->
                <ng-container *ngIf="msg.data_count">
                  <markdown class="markdown-body" [data]="msg.output"></markdown>

                  <div class="mt-2" *ngIf="((msg.data_count > 0 ) && (msg.data_count < 3000))">
                    Still {{msg.data_count}} records available, if you like to get, excel export is available to
                    download
                  </div>

                  <div class="mt-2" *ngIf="((msg.data_count > 0 ) && (msg.data_count > 3000))">
                    The data count is {{msg.data_count}}, Export of huge data not allowed, due to size limit
                  </div>

                  <button [disabled]="msg.data_count > 3000" type="submit" (click)="export('excel', msg)"
                    style="margin-top: 10px;border: none;background-color: white;padding: 0px;">
                    <img src="./assets/images/excel.svg" matTooltip="Export To Excel"></button>
                </ng-container>
              </div>
            </div>

            <div class="loading" *ngIf="loading">
              <div class="dot"></div>
              <div class="dot"></div>
              <div class="dot"></div>
            </div>
          </div>

          <div class="chat-input mt-2">
            <input [(ngModel)]="userInput" name="message" (keydown.enter)="sendMessage()" [disabled]="liveDataFlag"
              placeholder="Type your message..." required />
            <button *ngIf="loading" style="border: none;background: none;" type="submit" (click)="onStop()"><img
                src="./assets/icons/stop_button.png" matTooltip="stop"></button>
            <button style="border: none;background: none;" type="submit" (click)="sendMessage()"><img
                src="./assets/icons/send_button.svg" matTooltip="send"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>